

<script>
    import RainbowTitle from "./RainbowTitle";

    export default {
        name: "BunName",
        extends: RainbowTitle,
        computed: {
            titleText: function () {
                return this.$store.state.curRecipe.name;
            }
        },
        watch: {
            titleText: function () {
                this.renderTitle()
            }
        }
    }
</script>